import { Box, Typography } from "@mui/material";

const InfoItem = ({
  label,
  value,
}: {
  label: string;
  value: string | number | undefined;
}) => (
  <Box sx={{ minWidth: "200px", flex: "1 0 auto" }}>
    <Typography variant="subtitle2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body1">{value || "Not Set"}</Typography>
  </Box>
);

export default InfoItem;
